var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: `product ${_vm.productTheme}` },
    [
      _c(
        "div",
        { staticClass: "wine-product-header" },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c("div", { staticClass: "wine-product-header-inner" }, [
                      _c(
                        "div",
                        { staticClass: "product-image-display" },
                        [
                          _c("ProductImageDisplay", {
                            attrs: { images: _vm.item.imagesGallery },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "product-info" },
                        [
                          _c(
                            "div",
                            { staticClass: "product-intro" },
                            [
                              _vm.showSeries
                                ? _c("div", { staticClass: "product-series" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.item.seriesLabel) +
                                        "\n                "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.item.brand && _vm.item.brand !== "unknown"
                                ? _c("div", { staticClass: "product-brand" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.item.brand) +
                                        "\n                "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "product-title" }, [
                                _c("h1", [_vm._v(_vm._s(_vm.item.title))]),
                                _vm._v(" "),
                                _vm.item.region && _vm.item.region !== "unknown"
                                  ? _c(
                                      "div",
                                      { staticClass: "product-region" },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.item.region) +
                                            "\n                  "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _vm.accoladeCount > 0
                                ? [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: "#wine-features-region",
                                        },
                                        on: { click: _vm.triggerAwardsTab },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "accolades-highlight",
                                          },
                                          [
                                            _c("div", { staticClass: "icon" }, [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 50 77.386",
                                                  },
                                                },
                                                [
                                                  _c("path", {
                                                    staticClass: "cls-1",
                                                    attrs: {
                                                      d: "M40.141,32.494h0c-.377-.288-.763-.565-1.154-.831a.618.618,0,0,1-.09-.061A24.649,24.649,0,0,0,30.518,28,25.211,25.211,0,0,0,19.48,28a24.673,24.673,0,0,0-8.448,3.654l0,0c-.4.266-.785.547-1.169.838a25,25,0,1,0,30.282,0ZM25,74.755a22.371,22.371,0,1,1,9.423-42.662.267.267,0,0,1,.046.02l.015.007.012.005.078.041h0l.213.108c.14.066.279.132.416.2.095.049.188.1.281.149.124.066.247.129.369.2.105.056.207.117.31.178s.223.125.33.191.22.134.33.2.2.122.3.188.225.149.335.225c.095.061.19.125.283.188.11.076.218.156.325.234s.189.132.281.2.184.142.277.213.212.161.315.244c.022.017.041.034.061.049.174.139.342.278.511.423l0,0A22.371,22.371,0,0,1,25,74.755Z",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    staticClass: "cls-1",
                                                    attrs: {
                                                      d: "M31.11,25.381a27.2,27.2,0,0,1,7.877,3.107L49.42,0H31.779L26.431,14.609l3.882,10.6C30.579,25.264,30.846,25.32,31.11,25.381Z",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    staticClass: "cls-1",
                                                    attrs: {
                                                      d: "M18.888,25.376A28.218,28.218,0,0,1,27.3,24.8L18.216,0H.573L11.011,28.488A27.41,27.41,0,0,1,18.888,25.376Z",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    staticClass: "cls-1",
                                                    attrs: {
                                                      d: "M37.768,37.405a19.546,19.546,0,0,0-4.424-2.846c-.032-.014-.064-.031-.1-.048a19.69,19.69,0,1,0,4.52,2.894Zm-8.1,18.363.953,5.569-5-2.631a1.351,1.351,0,0,0-1.252,0l-5,2.631.956-5.569a1.355,1.355,0,0,0-.386-1.19l-4.048-3.945,5.6-.812a1.348,1.348,0,0,0,1.012-.735l2.5-5.07,2.5,5.07a1.346,1.346,0,0,0,1.012.735l5.592.812-4.047,3.945A1.343,1.343,0,0,0,29.67,55.768Z",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "label" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.accoladeCount) +
                                                    " Awards & Reviews"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "product-description" },
                                [
                                  _vm.item.abstract
                                    ? _c("read-more", {
                                        staticClass: "item-description",
                                        attrs: {
                                          "max-chars": 240,
                                          text: _vm.item.abstract,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("KeyInfoDisplay", {
                            attrs: { content: _vm.item },
                          }),
                          _vm._v(" "),
                          _vm.item.product_links &&
                          _vm.item.product_links.length > 0
                            ? _c(
                                "div",
                                { staticClass: "product-links-element" },
                                [
                                  _c("label", { attrs: { for: "links" } }, [
                                    _vm._v(_vm._s(_vm.linksTitle)),
                                  ]),
                                  _vm._v(" "),
                                  _c("b-form-select", {
                                    attrs: {
                                      id: "links",
                                      options: _vm.linkOptions,
                                    },
                                    on: { change: _vm.linkChange },
                                    model: {
                                      value: _vm.currentLink,
                                      callback: function ($$v) {
                                        _vm.currentLink = $$v
                                      },
                                      expression: "currentLink",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("cart-add-block", {
                            key: _vm.$route.path,
                            attrs: {
                              node: _vm.item,
                              overriderrp: _vm.item.rrp,
                            },
                          }),
                          _vm._v(" "),
                          _c("TastingNotes", {
                            attrs: { notes: _vm.item.prev_tasting_notes },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.productDetailIsComplete
        ? _c("deferred-content-placeholder")
        : _c("wine-feature-section", {
            ref: "featureSection",
            attrs: {
              "wine-making-notes-data": _vm.item.wine_making,
              "reviews-data": _vm.item.reviews,
              "tasting-notes": _vm.item.tasting_notes,
              "awards-data": _vm.item.awards,
              "technical-notes-data": _vm.item.technical_notes,
              "faqs-data": _vm.faqs,
              "initial-pane": _vm.initialFeatureSectionPane,
            },
          }),
      _vm._v(" "),
      _vm.relatedProducts.length > 0
        ? _c("relatedProducts", {
            attrs: {
              "related-products": _vm.relatedProducts,
              theme: _vm.productTheme,
              "hover-card-setting": _vm.hoverCardSetting,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }